import { render, staticRenderFns } from "./healthCheck.vue?vue&type=template&id=2a12ded7&scoped=true"
import script from "./healthCheck.vue?vue&type=script&lang=js"
export * from "./healthCheck.vue?vue&type=script&lang=js"
import style0 from "./healthCheck.vue?vue&type=style&index=0&id=2a12ded7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12ded7",
  null
  
)

export default component.exports